import { WebFsLogLevel } from '@lucidlink/sdk';
export const LOG_LEVEL_CONFIG = {
    [WebFsLogLevel.TRACE]: {
        color: 'accent',
        text: 'Trace',
    },
    [WebFsLogLevel.DEBUG]: {
        color: 'informative',
        text: 'Debug',
    },
    [WebFsLogLevel.INFO]: {
        color: 'positive',
        text: 'Info',
    },
    [WebFsLogLevel.WARNING]: {
        color: 'alert',
        text: 'Warning',
    },
    [WebFsLogLevel.ERROR]: {
        color: 'negative',
        text: 'Error',
    },
};
